export const PERMISSIONS = Object.freeze({
  DASHBOARD_VIEW: "dashboard.view",
  SALES_VIEW: "sales_pipeline.view",
  SALES_PIPELINE_VIEW_PAYMENTS: "sales_pipeline.view_payments",
  SALES_PIPELINE_CREATE_PAYMENT_LINK: "sales_pipeline.create_payment_link",
  SALES_PIPELINE_RECORD_PAYMENT: "sales_pipeline.record_payment",
  SALES_PIPELINE_REVERSE_PAYMENT: "sales_pipeline.reverse_payment",
  PAYMENTS_VIEW: "payments.view",
  PAYMENTS_LOCK_INVOICE: "payments.lock_invoice",
  PAYMENTS_CREATE_LINK: "payments.create_link",
  PAYMENTS_RECORD_CASH: "payments.record_cash",
  PAYMENTS_REPORT_BANK_TRANSFER: "payments.report_bank_transfer",
  PAYMENTS_VERIFY_BANK_TRANSFER: "payments.verify_bank_transfer",
  PAYMENTS_MANAGE_SETTLEMENTS: "payments.manage_settlements",
  PAYMENTS_MANAGE_CHEQUES: "payments.manage_cheques",
  PAYMENTS_RECORD_ASSIGNED_CHEQUE: "payments.record_assigned_cheque",
  PAYMENTS_RECORD_ASSIGNED_POS: "payments.record_assigned_pos",
  PAYMENTS_RECORD_ASSIGNED_CASH: "payments.record_assigned_cash",
  PAYMENTS_RECONCILE_POS: "payments.reconcile_pos",
  PAYMENTS_RECONCILE_CASH: "payments.reconcile_cash",
  PAYMENTS_REVERSE_RECEIPTS: "payments.reverse_receipts",
  PAYMENTS_MANAGE_REFUNDS: "payments.manage_refunds",
  PAYMENTS_EXCEPTIONAL_RECONCILE: "payments.exceptional_reconcile",
  PAYMENTS_VIEW_ACCOUNTS_WORKSPACE: "payments.view_accounts_workspace",
  LEGACY_SALES_VIEW: "legacy_sales.view",
  OPERATIONS_VIEW: "operations.view",
  SUPPLIER_CHATS_VIEW: "supplier_chats.view",
  SUPPLIERS_VIEW: "suppliers.view",
  USERS_VIEW: "users.view",
  USER_APPROVALS_VIEW: "users.approvals.view",
  REPORTS_VIEW: "reports.view",
  REPORTS_OVERVIEW_VIEW: "reports.overview.view",
  PRICE_SEARCH_VIEW: "price_search.view",
  CUSTOMERS_VIEW: "customers.view",
  AI_ASSISTANT_VIEW: "ai_assistant.view",
  WATI_DIAGNOSTICS_VIEW: "diagnostics.wati.view",
  DEVELOPER_TOOLS_VIEW: "developer_tools.view",
  SETTINGS_VIEW: "settings.view",
  ACCESS_PRESETS_MANAGE: "settings.access_presets.manage",
  APPROVALS_VIEW: "approvals.view",
  APPROVALS_DECIDE: "approvals.decide",
  APPROVALS_APPLY: "approvals.apply_approved_operation",
  INTERNAL_CHAT_USE: "internal_chat.use",
});

export const PAGE_ROUTES = Object.freeze([
  { key: "sales", path: "/querysetv4", aliases: ["/"], label: "Sales Pipeline", permission: PERMISSIONS.SALES_VIEW, nav: true },
  { key: "dashboard", path: "/dashboard", label: "Dashboard", permission: PERMISSIONS.DASHBOARD_VIEW, nav: true },
  { key: "supplier-chats", path: "/whatsapp_messages", label: "Supplier Chats", permission: PERMISSIONS.SUPPLIER_CHATS_VIEW, nav: true },
  { key: "operations", path: "/operations-v2", matchPrefix: true, label: "Operations V2", permission: PERMISSIONS.OPERATIONS_VIEW, nav: true },
  { key: "accounts", path: "/payments/accounts", label: "Accounts", permission: PERMISSIONS.PAYMENTS_VIEW_ACCOUNTS_WORKSPACE, nav: true },
  { key: "ai", path: "/ai_assistant", label: "AI Assistant", permission: PERMISSIONS.AI_ASSISTANT_VIEW, nav: true },
  { key: "suppliers", path: "/suppliers", label: "SRM", permission: PERMISSIONS.SUPPLIERS_VIEW, nav: true },
  { key: "users", path: "/hrm", label: "HRM", permission: PERMISSIONS.USERS_VIEW, nav: true },
  { key: "reports", path: "/reports", label: "Reports", permission: PERMISSIONS.REPORTS_VIEW, nav: true },
  { key: "reports-overview", path: "/reports/overview", label: "Overview Report", permission: PERMISSIONS.REPORTS_OVERVIEW_VIEW },
  { key: "price-search", path: "/price-search", aliases: ["/search_results"], label: "Price Search", permission: PERMISSIONS.PRICE_SEARCH_VIEW, nav: true },
  { key: "customers", path: "/customers", label: "Customers", permission: PERMISSIONS.CUSTOMERS_VIEW, nav: true },
  { key: "account-approvals", path: "/users", label: "Pending User Accounts", permission: PERMISSIONS.USER_APPROVALS_VIEW },
  { key: "wati-diagnostics", path: "/whatsapp", label: "WATI Status", permission: PERMISSIONS.WATI_DIAGNOSTICS_VIEW },
  { key: "developer-tools", path: "/views-preview", label: "Views Preview", permission: PERMISSIONS.DEVELOPER_TOOLS_VIEW },
]);

export const firstAccessiblePath = can => PAGE_ROUTES.find(route => route.nav && can(route.permission))?.path || "/access-denied";
